import { List, Tooltip, Divider } from 'antd';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { usePromise, Button, Icon } from '@digital/ui';
import { getAllMensagemByConsolidadoPluriAnualId, ItemMensagem } from '@app/api/aContratarComentario'

interface ListMensagemProps {
    idLinha: string;
    recarregarMensagem: boolean;
}


const ListMensagem = (props: ListMensagemProps) => {
    const { idLinha, recarregarMensagem } = props
    const [mensgem, setMensagem] = useState<ItemMensagem[]>();


    useEffect(() => {
        carregarMensagem();
    }, [recarregarMensagem, idLinha]);

    const carregarMensagem = async () => {
        const mensagem = await getAllMensagemByConsolidadoPluriAnualId(idLinha);
        if (mensagem) {
            setMensagem(mensagem);
        }
    }

    return (
        <div>
            <List
                itemLayout="horizontal"
                dataSource={mensgem || []}
                renderItem={item => (
                    <List.Item>
                        <List.Item.Meta
                            title={
                                <a href="#">
                                    {item.nomeDoUsuario + ' - ' + item.dataHoraInclusao}
                                </a>
                            }
                            description={
                                <div>
                                    {item.mensagem}
                                    <Divider />
                                </div>
                            }
                        />
                    </List.Item>
                )}
            />
        </div>
    );
}

export default ListMensagem;

